import type { ComponentType } from 'react';
import type { TemplateId } from '@/types/portfolio';
import { MinimalTemplate } from './MinimalTemplate';
import { DevLogTemplate } from './DevLogTemplate';
import { CompassTemplate } from './CompassTemplate';
import { BatmanTemplate } from './BatmanTemplate';
import { SpidermanTemplate } from './SpidermanTemplate';
import type { TemplateProps } from './shared';

export type { TemplateProps } from './shared';

export const TEMPLATE_RENDERERS: Record<TemplateId, ComponentType<TemplateProps>> = {
  minimal: MinimalTemplate,
  'dev-log': DevLogTemplate,
  compass: CompassTemplate,
  batman: BatmanTemplate,
  spiderman: SpidermanTemplate,
};

export function getTemplateRenderer(id: TemplateId): ComponentType<TemplateProps> {
  return TEMPLATE_RENDERERS[id] ?? MinimalTemplate;
}
